"use strict";
var toIntegerOrInfinity = require("../internals/to-integer-or-infinity");
var toString = require("../internals/to-string");
var requireObjectCoercible = require("../internals/require-object-coercible");
var $RangeError = RangeError;
module.exports = function repeat(count) {
  var str = toString(requireObjectCoercible(this));
  var result = "";
  var n = toIntegerOrInfinity(count);
  if (n < 0 || n === Infinity) throw new $RangeError("Wrong number of repetitions");
  for (; n > 0; (n >>>= 1) && (str += str)) if (n & 1) result += str;
  return result;
};
